import React from 'react';

import ErrorReporter from 'app/components/ErrorReporter';
import IndividualRecipientItem from './IndividualRecipientItem';
import GroupRecipientItem from './GroupRecipientItem';
import OrganizationRecipientItem from './OrganizationRecipientItem';
import GroupChatRecipientItem from './GroupChatRecipientItem';
import LimitedGroupRecipientItem from './LimitedGroupRecipientItem';
import type { ComposerRecipients_composerRecipients_recipients } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';
import { DisabledComposerListItemCopy } from 'constants/CopyConstants';
import SettingsStore from 'stores/SettingsStore';
import CurrentUser from 'auth/CurrentUser';

type Props = {
  entity: ComposerRecipients_composerRecipients_recipients,
  recipientIsSelected: boolean,
  districtIsSelected: boolean,
  nonDistrictRecipientIsSelected: boolean,
  selectionLength: number,
};

export default class RecipientItem extends React.Component<Props> {
  render() {
    const { entity, recipientIsSelected, districtIsSelected, nonDistrictRecipientIsSelected, selectionLength } = this.props;

    if (entity.__typename === 'TextHeader') {
      return null;
    }

    const sendToFewLimit = SettingsStore.getSetting('composer', 'send_to_few', 'recipient_limit') || 20;
    const aboveSendToFewLimit = selectionLength >= sendToFewLimit;
    const anotherDistrictIsSelected = districtIsSelected && !recipientIsSelected;

    let disabledCopy;

    if (anotherDistrictIsSelected) {
      disabledCopy = DisabledComposerListItemCopy.DISTRICT_IS_SELECTED;
    } else if (aboveSendToFewLimit && !recipientIsSelected) {
      disabledCopy = DisabledComposerListItemCopy.SEND_TO_FEW_LIMIT_REACHED(sendToFewLimit);
    }

    if (entity.recipient.type === 'individual') {
      return <IndividualRecipientItem entity={entity} recipientIsSelected={recipientIsSelected} disabledCopy={disabledCopy} />;
    } else if (entity.recipient.type === 'group') {
      if (CurrentUser.getUser().hasFeature('free_product_limits.web.apr-19') && entity.recipient.hasLimitedSendFunctionality) {
        return <LimitedGroupRecipientItem entity={entity} />;
      } else {
        return <GroupRecipientItem entity={entity} recipientIsSelected={recipientIsSelected} disabledCopy={disabledCopy} />;
      }
    } else if (entity.recipient.type === 'district') {
      return (
        <OrganizationRecipientItem entity={entity} recipientIsSelected={recipientIsSelected} disabledCopy={nonDistrictRecipientIsSelected ? DisabledComposerListItemCopy.NONDISTRICT_RECIPIENT_IS_SELECTED : disabledCopy} />
      );
    } else if (entity.recipient.type === 'group_chat') {
      return <GroupChatRecipientItem entity={entity} recipientIsSelected={recipientIsSelected} disabledCopy={disabledCopy} />;
    }

    return <ErrorReporter error="empty content in RecipientItem" />;
  }
}
